import { logger } from '@teko/log';
import { inIframe } from '@teko/utils';
import { isServerless } from '../helpers';

/**
 * Get data passed from container (staff admin) to iframe (current app)
 */
export const getDataFromIframe = (): DataFromIframe => {
  try {
    return JSON.parse(window.name);
  } catch (e) {
    logger.error('An error occurred when getting data from Iframe', e);
    return {};
  }
};

export const sendOrderPostMessage = ({ orderId }: { orderId: string }) => {
  // only send if being on client side and in an iframe
  if (!isServerless() || !inIframe() || !orderId) {
    return;
  }

  const existedOrderId = localStorage.getItem(SENT_POST_MESSAGE_ORDER_ID) || '';

  // only send if orderId is different than existed order Id in local storage
  if (existedOrderId === orderId) {
    return;
  }

  const message = JSON.stringify({ status: OrderStatus.SUCCESS, orderId });

  // send the message to the parent iframe
  window.parent.postMessage(message, '*');

  // save to local storage (avoid sending multiple postMessage)
  localStorage.setItem(SENT_POST_MESSAGE_ORDER_ID, orderId);
};

interface DataFromIframe {
  clientId?: string;
  oauthDomain?: string;
}

enum OrderStatus {
  SUCCESS = 'ORDER_SUCCESS',
}

const SENT_POST_MESSAGE_ORDER_ID = 'sent-post-message-order-id';
